import * as actionTypes from "../../Redux/Actions/actionTypes";

const initialState = {
  success: "",
  error: "",
};

const RecoverPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.RECOVER_PASSWORD_RESPONSE:
      return {
        ...state,
        success: action.success,
        error: "",
      };
    case actionTypes.RECOVER_PASSWORD_ERROR:
      return {
        ...state,
        error: action.error,
        success: "",
      };
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default RecoverPasswordReducer;
